import { Button } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginContext } from '../../context/LoginProvider';

interface Props {

}

const LoginWithGoogle : React.FC<Props> = () => {
    const {t} = useTranslation("common");
    const {loggedIn, login, logout} = useContext(LoginContext);
    
    return <>
        {!loggedIn && <Button name="loginWithGoogle" type='button' variant='contained' onClick={() => login()}>{t("common.login.google")}</Button>}
        {!!loggedIn && <Button name="logout" type='button' variant='contained' onClick={() => logout()}>{t("common.logout.google")}</Button>}
    </>
}

export default LoginWithGoogle;